import { useState } from 'react';

/**
 * Hook personalizado para manejar el estado de los modales
 */
const useModales = () => {
    const [showModalNuevoSoporte, setShowModalNuevoSoporte] = useState(false);
    const [showModalEliminar, setShowModalEliminar] = useState(false);
    const [showModalCombinarClientes, setShowModalCombinarClientes] = useState(false);
    const [showModalSeguimientoLead, setShowModalSeguimientoLead] = useState(false);
    const [showModalDatosFiscalesIncompletos, setShowModalDatosFiscalesIncompletos] = useState(false);

    const abrirModalNuevoSoporte = () => setShowModalNuevoSoporte(true);
    const cerrarModalNuevoSoporte = () => setShowModalNuevoSoporte(false);
    
    const abrirModalEliminar = () => setShowModalEliminar(true);
    const cerrarModalEliminar = () => setShowModalEliminar(false);
    
    const abrirModalCombinarClientes = () => setShowModalCombinarClientes(true);
    const cerrarModalCombinarClientes = () => setShowModalCombinarClientes(false);
    
    const abrirModalSeguimientoLead = () => setShowModalSeguimientoLead(true);
    const cerrarModalSeguimientoLead = () => setShowModalSeguimientoLead(false);
    
    const abrirModalDatosFiscalesIncompletos = () => setShowModalDatosFiscalesIncompletos(true);
    const cerrarModalDatosFiscalesIncompletos = () => setShowModalDatosFiscalesIncompletos(false);

    return {
        // Estados
        showModalNuevoSoporte,
        showModalEliminar,
        showModalCombinarClientes,
        showModalSeguimientoLead,
        showModalDatosFiscalesIncompletos,
        
        // Setters (para compatibilidad con código existente)
        setShowModalNuevoSoporte,
        setShowModalEliminar,
        setShowModalCombinarClientes,
        setShowModalSeguimientoLead,
        setShowModalDatosFiscalesIncompletos,
        
        // Métodos semánticos
        abrirModalNuevoSoporte,
        cerrarModalNuevoSoporte,
        abrirModalEliminar,
        cerrarModalEliminar,
        abrirModalCombinarClientes,
        cerrarModalCombinarClientes,
        abrirModalSeguimientoLead,
        cerrarModalSeguimientoLead,
        abrirModalDatosFiscalesIncompletos,
        cerrarModalDatosFiscalesIncompletos
    };
};

export default useModales;
